import React, { useEffect } from 'react';
import proj4 from 'proj4';

export const WMTSInitializer = () => {
    useEffect(() => {
        // NOTE(bjarne): Defining these aliases so we can easily convert incoming tilesets who
        // use any of these projections.
        proj4.defs('urn:ogc:def:crs:epsg::4326', proj4.defs('EPSG:4326'));
        proj4.defs('urn:ogc:def:crs:epsg:6.18.3:3857', proj4.defs('EPSG:3857'));
        proj4.defs('urn:ogc:def:crs:epsg::3857', proj4.defs('EPSG:3857'));
    }, []);

    return <></>;
};
